import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch branches with optional filters
export const getBranches = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Branch/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching branches:", error);
    throw error;
  }
};

// API to insert or update a branch
export const saveBranch = async (branchData) => {
  const response = await axios.post(`${BASE_URL}/api/Branch/save`, branchData, {
    headers: getAuthHeader(),
  });
  return response.data;
};
